import React from 'react';
import MobilePromotionForm from '../../integrations/mobile/MobilePromotionForm';

const CreatePromotionFormContainer = () => {
  return (
    <div>
      <MobilePromotionForm />
    </div>
  );
};

export default CreatePromotionFormContainer;
